import VueApexCharts from "vue-apexcharts";
import topReport from "@/views/reportwithdraw/top/top.vue";
import tableReport from "@/views/reportwithdraw/table/table.vue";
import {
    getTopSellReport,
    getGraphSellReport,
    getTableSellReport,
} from "@/service/reportsellcourse/reportsellcourse";


export default {
    components: {
        topReport,
        tableReport,
        apexchart: VueApexCharts,
    },
    mounted() {
        this.initialize();
    },

    data() {
        return {
            dataTop: {},
            dataGraph: {},
            dataTable: {},
        }
    },
    watch: {

    },
    methods: {
        async initialize() {
            this.dataTop = await getTopSellReport()
            this.dataGraph = await getGraphSellReport()
            this.dataTable = await getTableSellReport()
        }
    }
}